import { ModalCustom } from '$src/components/Modal';
import PropTypes from 'prop-types';
import { MotionZonesIcon } from '@ring-icons';
import useFeature from '$src/hooks/useFeature';
import { redirectToWatchZonesInRingApp } from '$src/utils/redirect';

import './index.less';


export default function MonitoringZonesModal({ showModal, handleClick, locationId }) {
  // Flag name predates its current use: it now only gates the Open Ring App button
  const [isOpenRingAppEnabled] = useFeature('stark-feature-next-monitoring-zones-web-redirect');

  const handleOk = () => {
    if (isOpenRingAppEnabled) {
      redirectToWatchZonesInRingApp(locationId);
    }
    handleClick();
  };

  return (
    <ModalCustom
      title="Watch Zone"
      data-testid="monitoring-zones-modal"
      contentTitle={
        <>
          <MotionZonesIcon className="monitoring-zones-modal__icon" width="42px" />
          <h1>Review your suggested Watch Zones in the Ring app.</h1>
        </>
      }
      {...(!isOpenRingAppEnabled && { cancelButtonProps: { style: { display: 'none' } } })}
      width="650px"
      contentMessage={
        <div className="monitoring-zones-modal__container">
          <div className="monitoring-zones-modal__line">
            <p> Watch Zones show our Agents where to focus when monitoring an event.  </p>
          </div>
          <div className="monitoring-zones-modal__line">
            <p>If there’s monitoring beyond the Watch Zone, our Agents won’t be notified. </p>
          </div>
          <div className="monitoring-zones-modal__line">
          <p>Use your Ring app to review your Watch Zone. </p>
          </div>
        </div>
      }
      visible={showModal}
      handleOk={handleOk}
      setModalVisible={handleClick}
      okText={isOpenRingAppEnabled ? 'Open Ring App' : 'Got It'}
      cancelText="Got It"
      className="monitoring-zones-modal modal-wrapper"
    />
  );
}

MonitoringZonesModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handleClick: PropTypes.func,
  locationId: PropTypes.string,
};
